// src/components/about-usPage.js
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Fade, Slide, Zoom } from 'react-awesome-reveal';
import { FaCheckCircle, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram,FaLaptopCode,FaRegLightbulb, } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <div>
      {/* ==================== 1. Page Header (Breadcrumb) ==================== */}
      <section className="py-5 text-center d-flex align-items-center" style={{
        minHeight: '40vh',
        background: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("/assets/banner/breadcrumb.jpg") no-repeat center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed'
      }}>
        <Container className="position-relative" style={{ zIndex: 2 }}>
          <Fade triggerOnce direction="down">
            <h1 className="display-4 fw-bold mb-3 text-white">About Us</h1>
            <p className="lead text-white-50">Home / About Us</p>
          </Fade>
        </Container>
      </section>

      <section className="bg-light-amiso">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6} className="mb-4 mb-lg-0">
                    <Slide triggerOnce direction="left">
                      <div className="position-relative">
                        <img src="/assets/about-us/about.jpg" alt="Webbloom" className="img-fluid rounded-3 shadow-lg" />
                        {/* <div className="position-absolute d-flex flex-column align-items-center justify-content-center text-white p-3 rounded-circle" 
                             style={{ bottom: '20px', left: '20px', backgroundColor: 'var(--thm-base)', width: '120px', height: '120px', fontWeight: 'bold' }}>
                          <span className="fs-3">Founded</span>
                          <span className="fs-4">1966</span>
                        </div> */}
                      </div>
                    </Slide>
                  </Col>
                  <Col lg={6}>
                    <Slide triggerOnce direction="right">
                      <span className="text-divider d-block mb-3">About Us</span>
                      <h2 className="section-title text-white mb-4">
                       We build websites that grow your business
                      </h2>
                      <p className="section-subtitle text-muted mb-4">
                       Webbloom is a modern web development company focused on creating powerful, scalable, and visually engaging digital solutions. We specialize in HTML websites, WordPress development, custom web applications, mobile apps, and SEO services tailored to help businesses grow online.
                      </p>
                      
                      <Row className="mb-4">
                        <Col md={6}>
                          <div className="d-flex align-items-center mb-3">
                            <FaLaptopCode size={30} className=" me-3" />
                            <div>
                              <h5 className="fw-bold text-white mb-1">Web solutions</h5>
                              <p className="text-muted small mb-0">Smart, scalable websites built for performance and growth.</p>
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="d-flex align-items-center mb-3">
                            <FaRegLightbulb size={30} className=" me-3" />
                            <div>
                              <h5 className="fw-bold text-white mb-1">Best interface</h5>
                              <p className="text-muted small mb-0">Clean, modern designs focused on user experience.</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                       <Button as={NavLink} to="/contact-us" variant="primary" size="lg">Contact Us</Button>
                    </Slide>
                  </Col>
                </Row>
              </Container>
            </section>

      {/* ==================== 3. Meet the Team ==================== */}
      <section className="bg-light-amiso text-center d-none">
        <Container>
          <Fade triggerOnce direction="down">
            <span className="text-divider d-block mb-3">// Our Professionals</span>
            <h2 className="section-title text-white mb-5">Meet the experts behind the scenes</h2>
          </Fade>

          <Row className="justify-content-center">
            {/* Team Member 1 */}
            <Col lg={4} md={6} className="mb-4">
              <Zoom triggerOnce delay={100}>
                <Card className="amiso-card h-100 p-3">
                  <Card.Img 
                    variant="top" 
                    src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" 
                    alt="John Doe" 
                    className="rounded-3" 
                  />
                  <Card.Body className="p-4 text-center">
                    <h4 className="fw-bold text-white mb-1">John Doe</h4>
                    <p className="text-primary text-uppercase small fw-bold mb-3">Creative Director</p>
                    <div className="d-flex justify-content-center">
                      <a href="#" className="text-white-50 mx-2"><FaFacebookF /></a>
                      <a href="#" className="text-white-50 mx-2"><FaTwitter /></a>
                      <a href="#" className="text-white-50 mx-2"><FaLinkedinIn /></a>
                      <a href="#" className="text-white-50 mx-2"><FaInstagram /></a>
                    </div>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Team Member 2 */}
            <Col lg={4} md={6} className="mb-4">
              <Zoom triggerOnce delay={300}>
                <Card className="amiso-card h-100 p-3">
                  <Card.Img 
                    variant="top" 
                    src="https://images.unsplash.com/photo-1573496384032-41ba9560be6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" 
                    alt="Jane Smith" 
                    className="rounded-3" 
                  />
                  <Card.Body className="p-4 text-center">
                    <h4 className="fw-bold text-white mb-1">Jane Smith</h4>
                    <p className="text-primary text-uppercase small fw-bold mb-3">Lead Developer</p>
                    <div className="d-flex justify-content-center">
                      <a href="#" className="text-white-50 mx-2"><FaFacebookF /></a>
                      <a href="#" className="text-white-50 mx-2"><FaTwitter /></a>
                      <a href="#" className="text-white-50 mx-2"><FaLinkedinIn /></a>
                      <a href="#" className="text-white-50 mx-2"><FaInstagram /></a>
                    </div>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Team Member 3 */}
            <Col lg={4} md={6} className="mb-4">
              <Zoom triggerOnce delay={500}>
                <Card className="amiso-card h-100 p-3">
                  <Card.Img 
                    variant="top" 
                    src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" 
                    alt="Robert Wilson" 
                    className="rounded-3" 
                  />
                  <Card.Body className="p-4 text-center">
                    <h4 className="fw-bold text-white mb-1">Robert Wilson</h4>
                    <p className="text-primary text-uppercase small fw-bold mb-3">UX Researcher</p>
                    <div className="d-flex justify-content-center">
                      <a href="#" className="text-white-50 mx-2"><FaFacebookF /></a>
                      <a href="#" className="text-white-50 mx-2"><FaTwitter /></a>
                      <a href="#" className="text-white-50 mx-2"><FaLinkedinIn /></a>
                      <a href="#" className="text-white-50 mx-2"><FaInstagram /></a>
                    </div>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AboutPage;